// extracted by mini-css-extract-plugin
module.exports = {"box":"NotificationBox_box__2Jl8d"};